// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeatureItem_wrapper__yVre7","icon":"FeatureItem_icon__5mpoa","title":"FeatureItem_title__X1gKh","text":"FeatureItem_text__LGepP"};